// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AJ88M","title":"styles_title__pdw7n","line":"styles_line__1gBwd","wrap":"styles_wrap__MTAIE","draggable":"styles_draggable__CFf0I"};